/**
 * @generated SignedSource<<fec3eaddccd2050210613832be7af0e8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsLabelEditPageQuery$variables = {
  id: string;
};
export type SettingsLabelEditPageQuery$data = {
  readonly label: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"LabelEditForm_label" | "LabelSidebar_label">;
  } | null;
};
export type SettingsLabelEditPageQuery = {
  response: SettingsLabelEditPageQuery$data;
  variables: SettingsLabelEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsLabelEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "label",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LabelEditForm_label"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "LabelSidebar_label"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SettingsLabelEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Label",
        "kind": "LinkedField",
        "name": "label",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b269b280b780a09a30384ad313490a16",
    "id": null,
    "metadata": {},
    "name": "SettingsLabelEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsLabelEditPageQuery(\n  $id: ID!\n) {\n  label(id: $id) {\n    name\n    ...LabelEditForm_label\n    ...LabelSidebar_label\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment LabelEditForm_label on Label {\n  id\n  name\n}\n\nfragment LabelSidebar_label on Label {\n  ...EntitySidebar_entity\n}\n"
  }
};
})();

(node as any).hash = "5deb7694f7a2f21ccacd295991195c50";

export default node;
